<template>
  <div class="container page" :class="{ 'embedded-root': embedded }">
    <van-nav-bar v-if="!embedded" :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main" :class="{ 'embedded-main': embedded }">
      <van-pull-refresh
        :pulling-text="$t('common.pull_to_refresh')"
        :loosing-text="$t('common.release_to_refresh')"
        :loading-text="$t('common.loading')"
        :success-text="$t('reservation.refresh')"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <!-- 最近投票-表格容器：5列：期号/类型/投票内容/票数/操作 -->
        <div class="vote-record-wrap">
          <table class="vote-record-table" cellpadding="0" cellspacing="0" border="0">
            <thead>
              <tr>
                <th class="col-expect">{{$t('record.issue_no')}}</th>
                <th class="col-type">{{$t('record.type')}}</th>
                <th class="col-content">{{$t('record.vote_content')}}</th>
                <th class="col-money">{{$t('record.votes')}}</th>
                <th class="col-action">{{$t('record.action')}}</th>
              </tr>
            </thead>
            <tbody v-if="list && list.length > 0">
              <tr v-for="(v, i) in list" :key="i" :class="{ 'row-alt': i % 2 === 1 }">
              <td class="col-expect">{{ formatExpect(v.expect) }}</td>
                <!-- 类型列：订单状态；除了"已结算"保持默认，其他状态全部显示红色 -->
                <td class="col-type">
                  <span :class="{ 'status-red': v.status_text && v.status_text !== '已结算' }">
                    {{ v.status_text || v.name || '-' }}
                  </span>
                </td>
                <!-- 投票内容列：客户的具体选择（甜/言/蜜/语） -->
                <td class="col-content vote-content-cell">
                  <template v-if="v.type">{{ v.type }}</template>
                  <template v-else-if="v.type_text">{{ v.type_text }}</template>
                  <template v-else-if="v.play_type">{{ v.play_type }}</template>
                  <template v-else>-</template>
                </td>
                <td class="col-money">{{ v.money }}</td>
                <td class="col-action">
                  <!-- 操作按钮颜色：已结算赢绿 / 已结算输红 / 待结算灰（默认）
                       calcOrderResult 返回 {winState:'win'|'lose'|'pending', profit} -->
                  <button
                    type="button"
                    class="record-action-btn"
                    :class="{
                      'btn-win':  calcOrderResult(v).winState === 'win',
                      'btn-lose': calcOrderResult(v).winState === 'lose'
                    }"
                    @click="openDetail(v)"
                  >{{$t('record.detail')}}</button>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 空状态：文档图标 + "当天没数据" -->
          <div class="record-empty" v-if="!list || list.length === 0">
            <div class="empty-icon">
              <svg viewBox="0 0 128 128" width="120" height="120" xmlns="http://www.w3.org/2000/svg">
                <rect x="32" y="16" width="64" height="96" rx="8" ry="8" fill="#f5f5f5" stroke="#dcdcdc" stroke-width="3"/>
                <rect x="44" y="36" width="40" height="4" rx="1.5" fill="#dcdcdc"/>
                <rect x="44" y="48" width="40" height="4" rx="1.5" fill="#dcdcdc"/>
                <rect x="44" y="60" width="40" height="4" rx="1.5" fill="#dcdcdc"/>
                <rect x="44" y="72" width="28" height="4" rx="1.5" fill="#dcdcdc"/>
                <rect x="44" y="88" width="12" height="6" rx="1" fill="#e8e8e8"/>
                <rect x="60" y="88" width="24" height="6" rx="1" fill="#e8e8e8"/>
              </svg>
            </div>
            <p class="empty-text">{{$t('record.no_data_today')}}</p>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <!-- 详情弹窗：仅显示单个盈亏数字（正数绿/负数红，未结算--灰） -->
    <van-popup
      v-model="showProfitPopup"
      round
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="profit-popup-box">
        <div class="profit-title">{{$t('record.order_profit')}}</div>
        <div
          class="profit-num"
          :class="{
            'profit-num--win':  currentProfit != null && Number(currentProfit) > 0,
            'profit-num--lose': currentProfit != null && Number(currentProfit) < 0,
            'profit-num--draw': currentProfit != null && Number(currentProfit) === 0
          }"
        >
          <template v-if="currentProfit != null && currentProfit !== '' && !isNaN(Number(currentProfit))">
            {{ Number(currentProfit) > 0 ? '+' : '' }}{{ Number(currentProfit) }}
          </template>
          <template v-else>--</template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      list: [],
      showProfitPopup: false,
      currentProfit: null,
    };
  },
  methods: {
    // 格式化期号：去掉前4位年份（如 2026072754 → 072754），短于5位原样显示（与 Lottery 页一致）
    formatExpect(expect){
      if(!expect) return '';
      const str = String(expect).trim();
      if(str.length <= 4) return str;
      if(/^\d{4}/.test(str)) return str.slice(4);
      return str;
    },
    back(){
      return window.history.back();
    },
    getImgUrl(ico){
      if(!ico) return '';
      if(ico.startsWith('http')) return ico;
      return 'https://adm.toyzzshop.top' + ico;
    },
    onRefresh() {
      // 真刷新：重新拉取游戏记录，成功后关闭loading
      this.getUserGameList(() => {
        this.isLoading = false;
        this.$toast(this.$t("my.finish_task"));
      });
    },
    // =====================================================
    // 共用：订单胜负/盈亏 计算函数（对齐 hd.php settle 规则）
    // 返回：{ winState: 'win'|'lose'|'pending', profit: number|null }
    //   - win=盈利(绿) / lose=亏损(红) / pending=结算中(灰)
    // =====================================================
    calcOrderResult(v){
      if(!v) v = {};
      const voteType = String(v.type || v.type_text || v.play_type || '').trim();
      const betMoney = parseFloat(v.money) || 0;

      // 0) 结算状态：status=1 且 is_win=1|2 才叫"已结算"
      const statusVal = v.status != null ? parseInt(v.status, 10) : null;
      const isWinVal  = v.is_win != null ? parseInt(v.is_win, 10) : null;
      const isSettled = (statusVal === 1) && (isWinVal === 1 || isWinVal === 2);

      // 1) 赔率：优先 v.peilv（下单时已写入订单的真实赔率），兜底 1.95
      let odds = parseFloat(v.peilv);
      if (!odds || isNaN(odds) || odds <= 0) {
        odds = 1.95;
      }

      // 2) 找真实开奖码 opencode（如果记录自身有）
      let opencode = null;
      if (Array.isArray(v.opencode) && v.opencode.length >= 3) {
        opencode = v.opencode;
      }

      // 3) 前端自算盈亏（严格对齐 hd.php 后端 settle() 代码）
      //    仅"已结算" + 有投票内容 + 有本金 + 有开奖码 才自算，避免未开奖乱判
      let selfProfit = null;
      let selfWinBool = null;
      if (isSettled && voteType && betMoney > 0 && opencode && opencode.length >= 3) {
        const n1 = parseFloat(opencode[0]) || 0;
        const n2 = parseFloat(opencode[1]) || 0;
        const n3 = parseFloat(opencode[2]) || 0;
        const sum = n1 + n2 + n3;
        let win = false;
        if (voteType === '甜') win = (sum >= 11 && sum <= 18);
        else if (voteType === '言') win = (sum >= 3 && sum <= 10);
        else if (voteType === '蜜') win = (sum % 2 === 1);
        else if (voteType === '语') win = (sum % 2 === 0);
        else {
          const vn = parseFloat(voteType);
          if (!isNaN(vn) && vn >= 3 && vn <= 18 && vn === sum) win = true;
        }
        const won  = +(betMoney * odds).toFixed(2);
        const lost = -Number(betMoney.toFixed(2));
        selfProfit  = win ? won : lost;
        selfWinBool = win;
      }

      // 4) 最终 profit：前端自算 > 后端 profit > is_win 精确判断(is_win=1赢 / =2输 / =0不判)
      let profit = selfProfit;
      if (profit == null || (typeof profit === 'number' && isNaN(profit))) {
        profit = (v.profit !== undefined && v.profit !== null && v.profit !== '' && String(v.profit).trim() !== '')
          ? v.profit
          : null;
        if (profit == null) {
          if (v.amount != null && !isNaN(Number(v.amount))) {
            profit = v.amount;
          } else if (v.win_money != null) {
            profit = v.win_money;
          } else if (v.lose_money != null) {
            profit = -1 * Math.abs(Number(v.lose_money));
          } else if (isWinVal === 1) {
            profit = betMoney > 0 ? +(betMoney * odds).toFixed(2) : null;
          } else if (isWinVal === 2) {
            profit = betMoney > 0 ? -Number(betMoney.toFixed(2)) : null;
          }
          // isWinVal===0 / null：未结算，profit 保持 null
        }
      }

      // 5) 最终 winState：优先按自算胜负 → profit正负 → is_win；否则 pending
      let winState = 'pending';
      if (selfWinBool === true) winState = 'win';
      else if (selfWinBool === false) winState = 'lose';
      else if (profit != null && !isNaN(Number(profit))) {
        winState = Number(profit) > 0 ? 'win' : (Number(profit) < 0 ? 'lose' : 'pending');
      } else if (isWinVal === 1) winState = 'win';
      else if (isWinVal === 2) winState = 'lose';
      // status=0 / is_win=0 一律 pending（结算中），除非前面已经有明确结果
      if (statusVal === 0 || isWinVal === 0 || isWinVal == null) {
        if (selfWinBool == null && (profit == null || isNaN(Number(profit)))) {
          winState = 'pending';
        }
      }

      return { winState, profit };
    },
    // 最近投票 → 详情按钮点击：打开底部弹窗显示单个盈亏数字
    openDetail(v){
      const { profit } = this.calcOrderResult(v);
      this.currentProfit = profit;
      this.showProfitPopup = true;
    },
    getUserGameList(cb){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data || [];
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
        if (typeof cb === 'function') cb();
      }).catch(() => {
        if (typeof cb === 'function') cb();
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 28px;
}
::v-deep .van-loading__text {
  color: #000000;
  font-size: 28px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}
.container.page.embedded-root{
  position: relative !important;
  height: auto;
  background-color: #f2f2f5;
}
.container .main.embedded-main{
  height: calc(100vh - 160px);
  background-color: #f2f2f5;
  padding: 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.container .main.embedded-main ::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
}
.container .main.embedded-main ::v-deep .van-loading__text {
  color: #000000;
}
.container .main.embedded-main ::v-deep .van-empty__description {
  color: #888;
}

/* ================================
   最近投票 tab 表格样式（高仿5.png）
   ================================ */
.vote-record-wrap{
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
}
.vote-record-table{
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 26px;
  color: #333;
  thead{
    tr{
      background-color: #fafafa;
      border-bottom: 1px solid #eaeaea;
    }
    th{
      padding: 20px 8px;
      text-align: center;
      font-weight: 500;
      color: #333;
      font-size: 26px;
      border-bottom: 1px solid #eaeaea;
      white-space: nowrap;
    }
    th.col-expect  { width: 18%; }
    th.col-type    { width: 20%; }
    th.col-content { width: 28%; }
    th.col-money   { width: 16%; }
    th.col-action  { width: 18%; }
  }
  tbody{
    tr{
      background-color: #fff;
      border-bottom: 1px solid #f0f0f0;
      transition: background-color .15s ease;
      &:last-child{
        border-bottom: none;
      }
      &.row-alt{
        background-color: #fafafa;
      }
      &:active{
        background-color: #f5f5f5;
      }
    }
    td{
      padding: 22px 8px;
      text-align: center;
      font-size: 26px;
      color: #333;
      vertical-align: middle;
      word-break: break-all;
      line-height: 1.3;
    }
    td.col-expect{
      font-weight: 600;
      color: #222;
      font-variant-numeric: tabular-nums;
    }
    td.col-money{
      font-weight: 600;
      color: #ff253f;
      font-variant-numeric: tabular-nums;
    }
  }
}
/* 操作按钮：默认灰色（待结算状态） */
.record-action-btn{
  display: inline-block;
  padding: 10px 22px;
  font-size: 24px;
  color: #666;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background-color .15s ease, transform .1s ease, border-color .15s ease, color .15s ease;
  &:active{
    background-color: #eeeeee;
    transform: scale(0.96);
  }
}
/* 最近投票-已结算：赢 → 绿色实心按钮 */
.record-action-btn.btn-win{
  background-color: #07c160;
  color: #ffffff;
  border-color: #07c160;
  font-weight: 700;
  &:active{
    background-color: #06ad56;
    border-color: #06ad56;
    transform: scale(0.96);
  }
}
/* 最近投票-已结算：输 → 红色实心按钮 */
.record-action-btn.btn-lose{
  background-color: #ff253f;
  color: #ffffff;
  border-color: #ff253f;
  font-weight: 700;
  &:active{
    background-color: #e61f36;
    border-color: #e61f36;
    transform: scale(0.96);
  }
}
/* 最近投票空状态：居中文档图标 + 当天没数据文字 */
.record-empty{
  width: 100%;
  padding: 120px 24px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  .empty-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.9;
  }
  .empty-text{
    margin: 0;
    font-size: 28px;
    color: #999;
    letter-spacing: 1px;
  }
}
/* 类型列状态色：除了"已结算"，其他状态（待开奖/开彩中…）全部显示红色 */
.status-red{
  color: #ff253f !important;
  font-weight: 600;
}
/* 投票内容列：甜/言/蜜/语 稍微加大加粗，颜色用主题红 */
.vote-content-cell{
  font-weight: 700;
  font-size: 30px;
  color: #ff253f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 最近投票 → 详情盈亏弹窗 */
.profit-popup-box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 60px;
  box-sizing: border-box;
  gap: 40px;
}
.profit-title{
  font-size: 32px;
  font-weight: 500;
  color: #333;
  letter-spacing: 2px;
}
.profit-num{
  font-size: 120px;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  letter-spacing: 2px;
  text-align: center;
  /* 默认灰色（平局/无效数据） */
  color: #999;
}
/* 正数盈利：绿色 */
.profit-num--win{
  color: #07c160;
}
/* 负数亏损：红色 */
.profit-num--lose{
  color: #ff253f;
}
/* 0或平局：灰色保持默认 */
.profit-num--draw{
  color: #999;
}
</style>
